import { Option } from '@sapphire/result';

import { Category } from '../../models/category.model';
import { QuestionFormModel } from '../../models/question-detail.model';
import { QuestionPayloadDto } from '../dtos/question-detail.dto';
import { LocalizationPayloadMapper } from './localization-payload.mapper';

export class QuestionPayloadMapper {
  private readonly _localizationPayloadMapper = new LocalizationPayloadMapper();

  public toPayload(
    model: QuestionFormModel,
    allCategories: Category[],
  ): QuestionPayloadDto {
    const resolvedCategories = allCategories
      .filter((category) => model.categoryIds.includes(category.id))
      .map((category) => ({ id: category.id, label: category.label }));

    return {
      attribute_id: '',
      desc: model.desc,
      is_hidden: model.isHidden,
      cmp: model.companyIds,
      class: model.class,
      recency: model.recency,
      category: resolvedCategories,
      answer_order: Option.from(model.answerOrder).unwrapOr(1),
      type: model.type,
      tags: model.tags.join(','),
      buyer_text: model.buyerText,
      stem1: model.stem1,
      stem2: model.stem2,
      create_survey_question_order: Option.from(model.createSurveyOrder).mapOr(
        '',
        String,
      ),
      localizations: model.localizations.map((localization) =>
        this._localizationPayloadMapper.toPayload(localization),
      ),
    };
  }
}
